import React, { Component } from 'react'
import { connect } from 'react-redux'
import { closeModal } from '../../../../actions/app-modal.action'
import { checkUser, generateOtp, validateOtp } from '../../../../actions/authorization.action'
import { checkRedirection } from '../../../../actions/dnd-app.action'
import { otpSentFailed, setLoginFormValidated } from '../../../../actions/login-modal.action'
import { AlertMessageModalConstant } from '../../../../constants/alert-message.constant'
import UtilService from '../../../../services/util.service'
import "./otp-modal-v2.style.css"
import LoginModalService from "../../../../services/login-modal.service"
import OtpModalService from "../../../../services/otp-modal.service"
import { setOtpFormValidated } from '../../../../actions/otp-modal.action'
import ApiStatus from '../../../../constants/api-status.enum'

class OtpModalV2Component extends Component {

    checkNumberValidationWithLength = (event, length) => {
        UtilService.checkNumberValidationWithLength(event, length);
    }

    onKeyUpMobileNumber = (event) => {
        if(event && event.keyCode === 13 && !this.disableOtpButton()){
            this.onClickGetOtp()
        }
    }

    onChangeMobile = (event) => {
        const { setLoginFormValidated } = this.props;
        if (event && event.target && event.target.value) {
            event.target.value = event.target.value.replace(/[^0-9]/g,"")
            const value = event.target.value;
            if (LoginModalService.validateMobileNumber(value)) {
                const validForm = { valid: true, userId: value };
                setLoginFormValidated(validForm);
            }
            else {
                const validForm = { valid: false, userId: '' };
                setLoginFormValidated(validForm);
            }
        }
    }

    getOtpButtonValue = () => {
        const { checkUserApiStatus, generateOtpApiStatus } = this.props;
        return LoginModalService.getButtonValueV2(checkUserApiStatus, generateOtpApiStatus);
    }

    disableOtpButton = () => {
        const { checkUserApiStatus, generateOtpApiStatus, loginFormValidated } = this.props;
        return LoginModalService.disableButton(checkUserApiStatus, generateOtpApiStatus, loginFormValidated);
    }

    onClickGetOtp = () => {
        this.props.otpSentFailed('');
        this.props.checkUser()
    }

    closeModal = () => {
        this.props.closeModal();
        this.props.checkRedirection()
    }

    onChangeOtp = (event) => {
        const { setOtpFormValidated } = this.props;
        if (event && event.target && event.target.value) {
            event.target.value = event.target.value.replace(/[^0-9]/g,"")
            const value = event.target.value;
            if (OtpModalService.validateEnteredOtp(value)) {
                const otp = { valid: true, value: value }
                setOtpFormValidated(otp);
            }
            else {
                const otp = { valid: false, value: '' }
                setOtpFormValidated(otp);
            }
        }
    }

    resendOtp = () => {
        this.props.generateOtp();
    }

    onKeyUpOtp = (event) => {
        if(event && event.keyCode === 13 && !this.disableValidateOtpButton()){
            this.onClickValidateOtp()
        }
    }

    onClickValidateOtp = () => {
        this.props.otpSentFailed('');
        this.props.validateOtp();
    }

    disableValidateOtpButton = () => {
        const { validateOtpApiStatus, validateOtpApiResponse, authLoginApiStatus, otpFormValidated } = this.props;
        return OtpModalService.disableButton(validateOtpApiStatus, validateOtpApiResponse, authLoginApiStatus, otpFormValidated);
    }

    getValidateOtpButtonValue = () => {
        const { validateOtpApiStatus, validateOtpApiResponse, authLoginApiStatus } = this.props;
        return OtpModalService.getButtonValue(validateOtpApiStatus, validateOtpApiResponse, authLoginApiStatus);
    }

    getOtpErrorMessage = () => {
        const {validateOtpApiResponse} = this.props
        return OtpModalService.getOtpErrorMessage(validateOtpApiResponse)
    }

    render() {
        const { modalTitle, otpSentFailed, otpSentFailedMessage, enableOtpSection, invalidOtp, incorrectOtp, incorrectResponse, validateOtpApiStatus } = this.props;
        return (
            <>
                <div className="otp-v2-modal-container">
                    <div className="otp-v2-modal-header">
                        <p className="otp-v2-modal-title">{modalTitle}</p>
                        <button className="otp-v2-close-button" onClick={this.closeModal}>
                            <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M11.7744 0.355932C11.9179 0.210922 12.0496 0.115349 12.1692 0.069209C12.2889 0.0230694 12.4365 0 12.612 0C12.8353 0 13.0547 0.0659127 13.2701 0.19774C13.4855 0.329567 13.5932 0.507532 13.5932 0.731638C13.5932 0.8371 13.5613 0.942561 13.4974 1.04802C13.4336 1.15348 13.3538 1.25894 13.2581 1.36441L8.25641 6.74294L13.5932 12.5565C13.8644 12.8729 14 13.1168 14 13.2881C14 13.4991 13.8803 13.6704 13.641 13.8023C13.4017 13.9341 13.1544 14 12.8991 14C12.7236 14 12.5681 13.9703 12.4325 13.911C12.2969 13.8517 12.1413 13.7298 11.9658 13.5452L6.98803 8.12712L1.84274 13.6441C1.7151 13.7891 1.58747 13.8847 1.45983 13.9308C1.33219 13.9769 1.1886 14 1.02906 14C0.789742 14 0.558406 13.9374 0.335043 13.8121C0.11168 13.6869 0 13.5188 0 13.3079C0 13.1234 0.0957256 12.919 0.287179 12.6949L5.76752 6.80226L0.789744 1.36441C0.694017 1.25894 0.614245 1.15348 0.550427 1.04802C0.486609 0.942561 0.454701 0.8371 0.454701 0.731638C0.454701 0.507532 0.578346 0.329567 0.825641 0.19774C1.07294 0.0659127 1.30826 0 1.53162 0C1.70712 0 1.86268 0.0230694 1.99829 0.069209C2.1339 0.115349 2.2735 0.210922 2.41709 0.355932L7.05983 5.45763L11.7744 0.355932Z" fill="#696969" />
                            </svg>
                        </button>
                    </div>

                    <div className="otp-v2-modal-body">
                        <div className="otp-v2-input-container">
                            <div className="otp-v2-input-group">
                                <input
                                    className="otp-v2-input"
                                    placeholder="Enter your number"
                                    type="number"
                                    autoComplete="off"
                                    onKeyPress={(event) => this.checkNumberValidationWithLength(event, 9)}
                                    onChange={this.onChangeMobile}
                                    disabled={enableOtpSection}
                                    onKeyUp={(event) => {this.onKeyUpMobileNumber(event)}}
                                />
                                <label className="otp-v2-input-label" >MOBILE NUMBER </label>
                            </div>
                            {!enableOtpSection && otpSentFailed && <p className="otp-v2-input-message">{otpSentFailedMessage}</p>}
                        </div>

                        {enableOtpSection && <>
                            <div className="otp-v2-input-container">
                                <div className="otp-v2-input-group">
                                    <input
                                        className="otp-v2-input"
                                        placeholder="Enter OTP"
                                        type="number"
                                        autoComplete="off"
                                        onKeyPress={(event) => this.checkNumberValidationWithLength(event, 3)}
                                        onChange={this.onChangeOtp}
                                        onKeyUp={(event)=> {this.onKeyUpOtp(event)}}
                                    />
                                    <label className="otp-v2-input-label" >ONE TIME PASSWORD </label>
                                </div>
                                {validateOtpApiStatus === ApiStatus.SUCCESS && invalidOtp && <p className="otp-v2-input-message">{AlertMessageModalConstant.INVALID_OTP}</p>}
                                {validateOtpApiStatus === ApiStatus.SUCCESS && incorrectOtp && <p className="otp-v2-input-message">{AlertMessageModalConstant.INCORRECT_OTP}</p>}
                                {validateOtpApiStatus === ApiStatus.SUCCESS && incorrectResponse && <p className="otp-v2-input-message">{this.getOtpErrorMessage()}</p>}
                            </div>

                            <div className="otp-v2-subtext"><span>Didn’t Recieve OTP? </span><span className="otp-v2-color-red otp-v2-link" onClick={this.resendOtp}>Resend OTP</span></div>
                            {otpSentFailed && <p className="otp-v2-input-message">{otpSentFailedMessage}</p>}
                        </>}
                    </div>

                    <div className="otp-v2-modal-footer">
                        {!enableOtpSection && <button className="otp-v2-main-button" onClick={this.onClickGetOtp} disabled={this.disableOtpButton()}>{this.getOtpButtonValue()}</button>}
                        {enableOtpSection && <button className="otp-v2-main-button" onClick={this.onClickValidateOtp} disabled={this.disableValidateOtpButton()}>{this.getValidateOtpButtonValue()}</button>}
                    </div>
                </div>
            </>
        )
    }
}

const mapStateToProps = (state) => ({
    modalName: state.modalInfo.activeModal.modalName,
    modalTitle: state.modalInfo.activeModal.modalTitle,
    checkUserApiStatus: state.loginModalInfo.checkUserApiStatus,
    generateOtpApiStatus: state.loginModalInfo.generateOtpApiStatus,
    generateOtpApiResponse: state.loginModalInfo.generateOtpApiResponse,
    invalidAirtelNumber: state.loginModalInfo.invalidAirtelNumber,
    loginFormValidated: state.loginModalInfo.loginFormValidated,
    otpSentFailed: state.loginModalInfo.otpSentFailed,
    otpSentFailedMessage: state.loginModalInfo.otpSentFailedMessage,

    enableOtpSection: state.otpModalInfo.enableOtpSection,
    validateOtpApiStatus: state.otpModalInfo.validateOtpApiStatus,
    validateOtpApiResponse: state.otpModalInfo.validateOtpApiResponse,
    authLoginApiStatus: state.otpModalInfo.authLoginApiStatus,
    otpFormValidated: state.otpModalInfo.otpFormValidated,
    mobileNumber: state.loginModalInfo.userId,
    invalidOtp: state.otpModalInfo.invalidOtp,
    incorrectOtp: state.otpModalInfo.incorrectOtp,
    incorrectResponse: state.otpModalInfo.incorrectResponse
})

const mapDispatchToProps = (dispatch) => ({
    setLoginFormValidated: data => dispatch(setLoginFormValidated(data)),
    closeModal: () => dispatch(closeModal()),
    checkUser: () => dispatch(checkUser()),
    checkRedirection: () => dispatch(checkRedirection()),

    setOtpFormValidated: (otp) => dispatch(setOtpFormValidated(otp)),
    validateOtp: () => dispatch(validateOtp()),
    generateOtp: () => dispatch(generateOtp()),
    otpSentFailed: (message) => dispatch(otpSentFailed(message))
})

export const OtpModalV2 = connect(mapStateToProps, mapDispatchToProps)(OtpModalV2Component)